$('.header__toggle').on('click keyup', function (event) {
    if (event.type === 'click' || (event.type === 'keyup' && (event.keyCode === 13 || event.which === 13))) {
        $('.collapse').fadeIn();
        $('html').addClass('no-scroll');
    }
});

$('.collapse__toggle').on('click keyup', function (event) {
    if (event.type === 'click' || (event.type === 'keyup' && (event.keyCode === 13 || event.which === 13))) {
        $('.collapse').fadeOut();
        $('html').removeClass('no-scroll');
    }
});

$(window).on('resize', () => {
    if ($(window).width() >= 1400) $('.collapse').fadeOut();
});

$(document).keydown(function (e) {
    if (e.keyCode === 27) {
        if ($('.collapse:visible').length) {
            $('html').removeClass('no-scroll');
            $('.collapse').fadeOut();
        }
    }
});

// when tab outside collapse then close collapse
$(document).on('focusin', function (e) {
    if ($('.collapse:visible').length) {
        if (!$(e.target).closest('.collapse').length) {
            $('.collapse').fadeOut();
            $('html').removeClass('no-scroll');
        }
    }

    if ($('.blackdesk-privacy-cookie-popup:visible').length) {
        if (!$(e.target).closest('.blackdesk-privacy-cookie-popup').length) {
            $('.blackdesk-privacy-cookie-reject-button').trigger('click');
        }
    }
});
